var _path, _g, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgBadge = function SvgBadge(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6_6640)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_6_6640",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 3,
    width: 22,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 18.915C0.0161658 18.9012 0.0174093 18.8822 0.0211399 18.8621C0.0460104 18.7168 0.0833161 18.5792 0.150466 18.4492C2.38757 14.2272 4.53389 9.95471 6.77471 5.73398C7.04829 5.21759 7.26467 4.78455 7.71234 4.39442C9.23689 3.0662 11.5921 3.52703 12.5149 5.32871L15.1897 10.4787C16.0514 10.2161 16.9169 9.96987 17.7849 9.73251C18.6218 9.50398 19.522 9.23001 20.3652 9.05577C21.2369 8.87523 21.9395 9.53933 21.8102 10.4358C21.0727 13.1869 20.3764 15.9518 19.6042 18.6916C19.0906 19.8115 17.5611 19.9201 16.9094 18.8607C16.8684 18.7951 16.8311 18.7181 16.7938 18.6487C15.8972 17.0087 15.079 15.3193 14.2036 13.6679C14.1525 13.5719 14.0991 13.4772 14.0518 13.38L14.0257 13.3623C12.3445 13.9873 10.7242 14.7613 9.14611 15.616C6.90902 16.8268 4.72415 18.1652 2.57907 19.5337C2.24581 19.7458 1.75337 20.1423 1.37658 20.2054C0.838135 20.2938 0.294715 19.9907 0.0945078 19.4744C0.0522281 19.3658 0.0385492 19.2522 0.00248698 19.1424V18.915H0ZM4.26031 15.6804L6.49368 14.3724C7.96602 13.5404 9.45202 12.7273 10.9878 12.0227C11.6219 11.7324 12.2661 11.4711 12.9127 11.2122L10.417 6.40819C10.1297 5.88675 9.36374 5.89054 9.07897 6.41198L4.32001 15.5428L4.25907 15.6791L4.26031 15.6804ZM18.9924 11.8876L16.3274 12.6263L17.9614 15.7827L18.9936 11.8889L18.9924 11.8876Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_6_6640)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4986 10.3941L-1.01099 17.6867L0.703833 20.9617L14.2134 13.6679L12.4986 10.3928V10.3941Z",
    fill: "url(#paint0_linear_6_6640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.4974 5.34259L14.9994 10.4585L19.7957 19.6347L29.2937 14.5188L24.4974 5.34259Z",
    fill: "url(#paint1_linear_6_6640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.4777 3.42981L9.28162 4.20375L9.82255 5.89684L10.5375 6.63543C10.5375 6.63543 15.5713 16.3193 18.097 21.1852C18.5931 20.4011 19.1925 19.8531 19.6887 19.0691L16.3274 12.6263L15.0702 10.2501L12.5148 5.32995L12.2088 4.26562L11.4777 3.42981Z",
    fill: "url(#paint2_linear_6_6640)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-0.609253 17.4896L7.68007 1.82385L11.6096 4.06741L4.9866 14.5226L-0.609253 17.4896Z",
    fill: "url(#paint3_linear_6_6640)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.518 3.42983C22.6324 3.49042 22.6324 3.56618 22.63 3.68486C22.6237 3.94368 22.5989 4.20504 22.6461 4.46259C22.7443 4.99161 23.0676 5.44486 23.5116 5.72642C23.621 5.79586 23.968 5.95367 24.0302 6.02817C24.0414 6.04205 24.045 6.06099 24.0575 6.07362V6.17589C24.0352 6.21755 24.0115 6.26427 23.9606 6.27563C23.8785 6.29457 23.6695 6.27941 23.5726 6.27816C23.5489 6.27816 23.5266 6.26678 23.5054 6.26678C22.7966 6.26047 22.1897 6.56097 21.8117 7.17583C21.7446 7.28567 21.5754 7.6657 21.4983 7.71999C21.3876 7.79701 21.267 7.70485 21.2583 7.57859C21.2546 7.52683 21.2695 7.48642 21.2708 7.44223C21.2746 7.17962 21.2845 6.91195 21.2285 6.65439C21.1241 6.16957 20.8181 5.73273 20.4102 5.46633C20.2623 5.37037 20.0086 5.27315 19.8867 5.17088C19.781 5.08251 19.8196 4.91206 19.9489 4.89312C20.1367 4.86535 20.3928 4.91586 20.5955 4.90449C21.2297 4.86914 21.7819 4.49921 22.104 3.95378C22.1848 3.81616 22.2569 3.62931 22.3427 3.50431C22.3688 3.46643 22.3962 3.45381 22.4297 3.42856H22.5193L22.518 3.42983Z",
    fill: "#0C80DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6_6640",
    x1: 13.4836,
    y1: 18.4922,
    x2: 3.76835,
    y2: 14.6388,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#034AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.44,
    stopColor: "#034AA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0C80DF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6_6640",
    x1: 18.3259,
    y1: 25.2442,
    x2: 22.5649,
    y2: 9.91667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#9A55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#034AA6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6_6640",
    x1: 17.02,
    y1: 16.722,
    x2: 11.3516,
    y2: 5.74675,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9A55FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#ED6500"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E154FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6_6640",
    x1: 2.87884,
    y1: 15.8382,
    x2: 8.67267,
    y2: 4.98964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C80DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.59,
    stopColor: "#008DFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E154FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6_6640"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgBadge);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "Badge.4b1852290d210854feeeb3a494f31fd4.svg";